export default {"src":"/_next/static/media/sticker-7.7b70e859.svg","height":223,"width":250,"blurWidth":0,"blurHeight":0};